import { Component, OnInit } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { MoreInfoService } from 'src/app/shared/services/more-info.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-no-accounts-error',
  templateUrl: './no-accounts-error.component.html',
  styleUrls: ['./no-accounts-error.component.scss']
})
export class NoAccountsErrorComponent implements OnInit {
  assetsUrl = environment.assetsUrl;

  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/close-icon.svg',
    image: 'close-icon',
    title: 'Lo sentimos, no podemos continuar con la solicitud',
    content:
      'Verifica que el cliente tenga una cuenta AV Villas con saldo para fondear el CDT. Para hacer el fondeo por PSE, el cliente deberá volver a empezar el proceso de forma autogestionada.',
    link: {
      url: '/',
      text: 'Entendido'
    }
  };

  constructor(private moreInfoService: MoreInfoService) {}

  ngOnInit(): void {
    if (!this.moreInfoService.getMoreInfo().isAssistedSale) {
      this.config.content =
        'Verifica que tengas una cuenta AV Villas con saldo para fondear tu CDT.';
    }
  }
}
